import { render, staticRenderFns } from "./Webhook.vue?vue&type=template&id=1fec10f6&"
import script from "./Webhook.vue?vue&type=script&lang=js&"
export * from "./Webhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports